{
    "locale": "cs-CZ",
    "General": {
        "OrText": "Nebo",
        "Title_MyHubert": "My Hubert",
        "Button_GoTo_MyHubert": "Přejít na My Hubert"
    },
    "Header": {
        "ButtonText_CreateNewAccount": "Vytvořit nový účet",
        "ButtonText_SignInToYourAccount": "Přihlásit se k účtu",
        "ButtonText_StartInterviewWithoutSigningUp": "Spustit pohovor bez registrace",
        "ButtonText_StartInterviewWithoutSigningIn": "Spustit pohovor bez přihlášení",
        "Navlink_Dashboard": "Přehled",
        "Navlink_MyInterviews": "Moje pohovory",
        "Navlink_LearnWithHubert": "Učte se s Hubertem",
        "Navlink_HelpCenter": "Centrum nápovědy",
        "MyProfile": "Můj profil",
        "LogOut": "Odhlásit se"
    },
    "Login": {
        "MainTitle": "Chcete vidět výsledky svého pohovoru s Hubertem?",
        "Subtitle": "Přihlaste se, abyste viděli výsledky, získali zpětnou vazbu, přečetli si rady a mnohem více.",
        "LoginTitle": "Přihlaste se ke svému účtu Hubert",
        "Label_Email": "E-mail",
        "Label_Password": "Heslo",
        "ButtonText_SignIn": "Přihlásit se",
        "ButtonText_ForgotPassword": "Zapomenuté heslo?",
        "ButtonText_ContinueWithGoogle": "Pokračovat přes Google",
        "OrSeparator": "Nebo",
        "Error_Email_Required": "E-mail je povinný.",
        "Error_Email_Invalid": "Zadejte platný e-mail.",
        "Error_Password_Required": "Heslo je povinné.",
        "Error_Use_Same_Email_As_Interview": "Použijte prosím stejný e-mail, který jste uvedli v pohovoru"
    },
    "Registration": {
        "MainTitle": "Chcete vidět výsledky svého pohovoru s Hubertem?",
        "Subtitle": "Zaregistrujte se, abyste viděli výsledky, získali zpětnou vazbu, přečetli si rady a mnohem více.",
        "RegistrationTitle": "Vytvořit účet Hubert",
        "BenefitsBox_Title": "Můžete",
        "BenefitsBox_Point1": "Přistupovat k historii svých pohovorů",
        "BenefitsBox_Point2": "Získat zpětnou vazbu k pohovorům",
        "BenefitsBox_Point3": "Znovu použít odpovědi v nových pohovorech",
        "BenefitsBox_Point4": "Dostat rady k pohovorům",
        "BenefitsBox_Point5": "Číst kariérní průvodce",
        "BenefitsBox_Point6": "A mnohem více",
        "Label_FirstName": "Jméno",
        "Label_LastName": "Příjmení",
        "Label_Email": "E-mail",
        "Label_Password": "Heslo",
        "Label_PhoneNumber": "Telefonní číslo",
        "Label_TermsOfService": "Souhlasím s",
        "Label_TermsOfServiceLink": "Zásadami ochrany osobních údajů a Obchodními podmínkami",
        "Placeholder_CountryCode": "Vyberte předvolbu",
        "Placeholder_PhoneNumber": "601123456",
        "HelpText_Password": "Heslo musí mít alespoň 6 znaků.",
        "ButtonText_SignUp": "Zaregistrovat se",
        "ButtonText_SignUpWithGoogle": "Zaregistrovat se přes Google",
        "OrSeparator": "Nebo",
        "Error_FirstName_Required": "Jméno je povinné.",
        "Error_LastName_Required": "Příjmení je povinné.",
        "Error_Email_Required": "E-mail je povinný.",
        "Error_Email_Invalid": "Zadejte platný e-mail.",
        "Error_Email_Exists": "E-mail je již použit.",
        "Error_Password_Required": "Heslo je povinné.",
        "Error_Password_6_Characters": "Vaše heslo musí mít alespoň 6 znaků.",
        "Error_PhoneNumber_Required": "Telefonní číslo je povinné.",
        "Error_PhoneNumber_Invalid": "Telefonní číslo není platné.",
        "Error_PrivacyPolicyCheck_Required": "Je nutné přijmout Zásady ochrany osobních údajů a Obchodní podmínky."
    },
    "RegistrationInviteEmail": {
        "Subtitle_BeforeInterviewCompleted": "Abyste mohli absolvovat pohovor, stačí přijmout podmínky používání služby Hubert. Je to snadné, stačí zaškrtnout políčko vpravo.",
        "Subtitle_AfterInterviewCompleted": "Zaregistrujte se, abyste viděli výsledky, získali zpětnou vazbu, přečetli si rady a mnohem více.",
        "PrivacyPolicyText": "Stisknutím tlačítka registrace souhlasíte s",
        "PrivacyPolicyLink": "Zásadami ochrany osobních údajů a Obchodními podmínkami",
        "ButtonText_SignUp": "Zaregistrovat se a přejít k pohovoru",
        "ButtonText_SignUpNormal": "Zaregistrovat se",
        "ButtonText_SignInInstead": "Klikněte zde pro přihlášení"
    },
    "LoginInviteEmail": {
        "Subtitle": "Přihlaste se, abyste viděli výsledky, získali zpětnou vazbu, přečetli si rady a mnohem více."
    },
    "AppMessages": {
        "internal-server-error": "Došlo k neočekávané chybě",
        "invalid-credentials": "Neplatné přihlašovací údaje. Zkuste to prosím znovu.",
        "user-not-found": "Neplatné přihlašovací údaje. Zkuste to prosím znovu.",
        "account-not-found": "Neplatný účet. Zkuste to prosím znovu.",
        "verify-email-title": "Ověřte svůj e-mail",
        "verify-email-subtitle": "Zkontrolujte prosím svůj e-mail a ověřte svůj účet.",
        "email-not-verified-title": "E-mail není ověřen",
        "email-not-verified-subtitle": "Zkontrolujte prosím svůj e-mail a ověřte svůj účet.",
        "verifying-email-title": "Ověřování e-mailu",
        "verifying-email-subtitle": "Prosím čekejte ...",
        "sign-in-title": "Přihlašování",
        "sign-in-subtitle": "Prosím čekejte ...",
        "server-error": "Něco se pokazilo",
        "hubert-user-exists": "Účet již existuje",
        "account-exists": "Účet již existuje",
        "email-verified": "Váš e-mail byl ověřen",
        "email-is-taken": "E-mail je již použit",
        "re-enter-password": "K přihlášení použijte své heslo",
        "password-reset": "Vaše heslo bylo změněno",
        "re-enter-new-password": "K přihlášení použijte své nové heslo",
        "invalid-invitation": "Neplatná pozvánka.",
        "invalid-code": "Neplatný ověřovací kód.",
        "email-already-verified": "E-mail je již ověřen",
        "email-mismatch-title": "Neshoda e-mailu",
        "email-mismatch-subtitle": "Použijte prosím stejnou e-mailovou adresu, kterou jste použili při žádosti o práci."
    },
    "TransitionPage": {
        "loading-title": "Načítání ...",
        "loading-subtitle": "Připravujeme vše potřebné ...",
        "logout-title": "Načítání ...",
        "logout-subtitle": "Odhlašujete se..."
    },
    "ImpersonationPage": {
        "loading-title": "Načítání ...",
        "loading-subtitle": "Připravujeme vše potřebné ..."
    },
    "ProcessInvitation": {
        "loading-title": "Načítání ...",
        "loading-subtitle": "Počkejte chvíli, načítáme váš pohovor",
        "InvitationNotFound": "Váš pohovor nemůžeme najít.",
        "InvitationExpired": "Tento odkaz pro přístup k pohovoru vypršel.",
        "InvitationExpired_Description1": "Otevřete prosím pohovor z.",
        "InvitationExpired_Description2": "nebo kontaktujte svého personalistu.",
        "InvitationInvalid": "Odkaz na tuto pozvánku je neplatný.",
        "InterviewCompleted": "Tento pohovor již byl dokončen."
    },
    "Common": {
        "MyInterviews": {
            "Title": "Moje pohovory",
            "TableHead_Employer": "Zaměstnavatel",
            "TableHead_Job": "Pozice",
            "TableHead_Status": "Stav",
            "TableHead_ApplicationDate": "Datum přihlášky",
            "TableBody_StartInterview": "Pohovor není dokončen. Klikněte zde pro spuštění nebo pokračování v pohovoru.",
            "TableBody_NotScored": "Pohovor je dokončen a výsledky budou brzy k dispozici.",
            "TableBody_Details": "Klikněte zde pro zobrazení výsledků pohovoru a dalších informací.",
            "ApplicationDate_Invited": "Pozván",
            "ApplicationDate_MinuteAgo": "před minutou",
            "ApplicationDate_MinutesAgo": "před minutami",
            "ApplicationDate_HourAgo": "před hodinou",
            "ApplicationDate_HoursAgo": "před hodinami",
            "ApplicationDate_DayAgo": "před dnem",
            "ApplicationDate_DaysAgo": "před dny",
            "ButtonText_SeeAllInterviews": "Zobrazit všechny pohovory",
            "ButtonText_Details": "Podrobnosti",
            "ButtonText_StartInterview": "Přejít na pohovor",
            "ButtonText_NotScored": "Čekání na výsledky",
            "NoInterviews_Message": "Nemáte žádné záznamy o minulých ani nadcházejících pohovorech."
        },
        "LatestJobPostings": {
            "NoJobPostings": "Momentálně nejsou k dispozici žádné pracovní nabídky. Zkuste to znovu později."
        }
    },
    "Dashboard": {
        "MyCareer": {
            "Title": "Moje kariéra",
            "Subtitle": "Vyberte pohovor pro zobrazení hodnocení a svých vyhlídek.",
            "MostRecentInterview": "Nejnovější pohovor",
            "ToDo": "K vyřízení",
            "NoOngoingInterviews_Title": "Nemáte žádné nové pozvánky k pohovoru.",
            "NoOngoingInterviews_Subtitle": "Nové pohovory Hubert se zde zobrazí, jakmile je personalisté naplánují.",
            "NoRecentInterviews_Title": "Nemáme záznamy o vašem předchozím pohovoru.",
            "NoRecentInterviews_Subtitle": "Jakmile budete pozváni k pohovoru personalisty, zobrazí se níže.",
            "ButtonText_StartInterview": "Přejít na pohovor",
            "ButtonText_NotScored": "Čekání na výsledky",
            "ButtonText_Details": "Podrobnosti"
        },
        "LearnWithHubert": {
            "Title": "Učte se s Hubertem",
            "Subtitle": "Získejte rady, jak se zlepšit v přijímacích pohovorech a v práci.",
            "PickedForMe": "Nejnovější články",
            "ButtonText_SeeAllArticles": "Zobrazit všechny články"
        },
        "HubertTip": {
            "Title": "Tip od Huberta",
            "Subtitle": "Absolvujte pohovory rychleji.",
            "Description": "Hlásíte se na novou práci v podobné roli, pro kterou jste již dříve absolvovali pohovor Hubert? Můžete znovu použít své odpovědi z předchozího pohovoru a ušetřit čas.",
            "ButtonText_ReadMoreTips": "Přečíst další tipy"
        },
        "NewCandidateModalPopup": {
            "Title": "Vše je připraveno",
            "DescriptionLine1": "Váš účet je nyní připraven.",
            "DescriptionLine2": "Spravujte své pohovory a profil. Zobrazte si výsledky, získejte zpětnou vazbu a zjistěte více o tom, jak absolvovat pohovory. Bavte se.",
            "ButtonText_LetsGo": "Hurá"
        },
        "InterviewCompletedModal": {
            "Title": "Skvělá práce",
            "Subtitle": "Dokončili jste pohovor.",
            "Description": "Personalisté zkontrolují všechny žádosti a poskytnou zpětnou vazbu e-mailem nebo telefonicky, jakmile budou mít zprávu.",
            "ButtonText_Continue": "Pokračovat"
        },
        "LatestJobPostings": {
            "Title": "Nejnovější pracovní nabídky",
            "Subtitle": "Prozkoumejte další nabídky od partnerů Hubertu, které byly nedávno zveřejněny."
        }
    },
    "MyInterviews": {
        "MyInterviewsSection_Title": "Moje pohovory",
        "MyInterviewsSection_Subtitle": "Vyberte pohovor pro zobrazení hodnocení a kariérních příležitostí.",
        "MyInterviewsSection_ToDo": "K vyřízení"
    },
    "Interview": {
        "ButtonText_SeeAllInterviews": "Zobrazit všechny pohovory",
        "InterviewNotFound_Title": "Jejda. Přístup odepřen.",
        "InterviewNotFound_Description": "Pokoušíte se otevřít detaily pohovoru, které nejsou spojeny s vaším účtem.",
        "ButtonText_GoToAllInterviews": "Přejít na Moje pohovory",
        "InterviewDetails": {
            "Title": "Detaily pohovoru",
            "ForRole": "Pro roli",
            "InterviewCompletedOn": "Pohovor dokončen dne {{date}} v {{time}}"
        },
        "MyResult": {
            "Title": "Můj výsledek",
            "Subtitle": "Vyhodnocená shoda.",
            "ButtonText_LearnMore": "Jak Hubert posuzuje vaše odpovědi",
            "GotPotential_Title": "Silný potenciál, chybí jedna podmínka",
            "GotPotential_Description": "Vaše odpovědi působily silně pro tento typ role. Zároveň může být jedna povinná podmínka pro tuto konkrétní pozici nesplněná, nebo není z odpovědí dostatečně jasná. To může ovlivnit další postup a záleží na potřebách náboráře i počtu kandidátů. Pokud nepostoupíte dál, neznamená to automaticky, že nejste dobrý kandidát. Často jde o velmi konkrétní požadavky pro tuto jednu roli. Podívejte se na otázky níže a ujasněte, jak podmínku splňujete, například oprávnění, dostupnost nebo roky praxe.",
            "GotPotential_DescriptionSecondary": "Hodnocení Huberta je pouze orientační. Konečné rozhodnutí dělá náborář a výsledek mohou ovlivnit i další faktory, například počet kandidátů.",
            "GreatMatch_Title": "Silná shoda",
            "GreatMatch_Description": "Vaše odpovědi dobře odpovídají tomu, co náboráři u této role obvykle hledají, a splňujete požadavky pozice. Náborář projde všechny kandidáty a rozhodne o dalších krocích.",
            "GreatMatch_DescriptionSecondary": "Hodnocení Huberta je pouze orientační. Konečné rozhodnutí dělá náborář a výsledek mohou ovlivnit i další faktory, například počet kandidátů. Pokud nepostoupíte dál, neznamená to automaticky, že nejste dobrý kandidát. Často jde o velmi konkrétní požadavky pro tuto jednu roli. Podívejte se na otázky níže a ujasněte, jak podmínku splňujete, například oprávnění, dostupnost nebo roky praxe.",
            "OkMatch_Title": "Splňujete požadavky, přidejte větší dopad",
            "OkMatch_Description": "Splňujete požadavky pozice. Abyste vynikli, přidejte více jasnosti a důkazů. Jednoduchý způsob je jeden konkrétní příklad na otázku, co jste udělali a jaký byl výsledek, ideálně i s číslem nebo měřitelným dopadem.",
            "OkMatch_DescriptionSecondary": "Hodnocení Huberta je pouze orientační. Konečné rozhodnutí dělá náborář a výsledek mohou ovlivnit i další faktory, například počet kandidátů.",
            "NotClearMatch_Title": "Možná to zatím není ta správná shoda",
            "NotClearMatch_Description": "Podle tohoto pohovoru mohou být vaše odpovědi méně v souladu s tím, co tato role potřebuje, nebo je jedna podmínka nejasná. Začněte otázkami níže. Malé úpravy, více konkrétnosti a jasné výsledky často výrazně zlepší celkový dojem příště.",
            "NotClearMatch_DescriptionSecondary": "Hodnocení Huberta je pouze orientační. Konečné rozhodnutí dělá náborář a výsledek mohou ovlivnit i další faktory, například počet kandidátů."
        },
        "ScoreBox": {
            "ProfessionalExperiences": "Profesní zkušenosti, motivace a kompetence",
            "QualifyingRequirements": "Kvalifikační požadavky pro tuto konkrétní práci",
            "NotQualified_Title": "Posilte odpovědi",
            "NotQualified_Description": "Některé odpovědi mohly působit příliš obecně pro tuto roli. Níže uvidíte, kde pomůže konkrétní příklad, čísla nebo jasný výsledek.",
            "GreatResults_Title": "Silné odpovědi",
            "GreatResults_Description": "Vaše odpovědi naznačují, že se dobře hodíte na pozici, o kterou jste se ucházeli. Skvěle! Pokud je přesto nějaká otázka, jejíž odpověď může být vylepšena, uvidíte ji níže spolu se svou odpovědí.",
            "MeetingRequirements_Title": "Požadavky splněny",
            "MeetingRequirements_Description": "Vaše odpovědi ukazují, že splňujete kvalifikační požadavky stanovené pro tuto práci. Skvělá práce.",
            "NotAllExpectationsMet_Title": "Chybí jeden nebo více požadavků",
            "NotAllExpectationsMet_Description": "Na základě vašich odpovědí může být jeden nebo více požadavků nesplněných nebo nejasných, například certifikáty, oprávnění, úroveň vzdělání nebo roky praxe.",
            "ButtonText_FindOutPossibleReasons": "Zjistit možné důvody"
        },
        "ScriptFromInterview": {
            "Title": "Přečtěte si celý pohovor",
            "ButtonText_SeeWholeTranscript": "Číst pohovor",
            "ButtonText_DeleteInterview": "Smazat pohovor",
            "Loading_Title": "Načítání ...",
            "Loading_Subtitle": "Počkejte chvíli, načítáme přepis vašeho pohovoru."
        },
        "HowToImproveAtInterviews": {
            "Title": "Jak se zlepšit v pohovorech",
            "Subtitle_Questions": "Zde jsou otázky, u kterých by se vaše odpověď mohla zlepšit.",
            "Subtitle_NoQuestions": "Nenašli jsme žádné otázky, které by pro tuto práci vyžadovaly zásadní vylepšení.",
            "GreatMatch_Questions_Description": "I když jste pro tuto práci skvělou shodou, mohou existovat odpovědi, které lze zlepšit. Pokud jsme je našli, jsou uvedeny níže. Obecně platí: dodržujte pokyny před otázkou, popište situaci, své kroky a výsledek. Jednoslovná odpověď „OK“ není dostačující. Ani příliš dlouhé odpovědi nejsou ideální, cílem je, aby náborář nebo Hubert jasně pochopil vaše zkušenosti a kompetence, podobně jako při osobním pohovoru.",
            "GreatMatch_NoQuestions_Description": "Pravděpodobně jste odpověděli dobře na všechny nebo většinu otázek. Dobrá práce.",
            "OkMatch_Questions_Description": "Níže jsou otázky, u kterých může být vaše odpověď vylepšena. Dodržujte pokyny před otázkou, popište situaci, akce a výsledek. „OK“ nestačí, ale ani přílišné rozepisování není vhodné. Důležité je, aby náborář nebo Hubert jasně pochopil vaše kompetence.",
            "OkMatch_NoQuestions_Description": "Přestože jste hodnoceni jako OK shoda, nemusí zde být odpovědi, které by bylo možné výrazně zlepšit. Může to být tím, že náboráři mají vysoké nároky při velké konkurenci kandidátů s velmi dobrými odpověďmi.",
            "OkMatch_NoQuestions_DescriptionSecondary": "Obecné doporučení: řiďte se pokyny před otázkou, popište situaci, akci a výsledek. „OK“ nestačí, ale ani příliš dlouhá odpověď není ideální.",
            "GotPotential_Questions_Description": "I když máte pro tuto práci dobrý potenciál, mohou být odpovědi, které lze vylepšit. Pokud jsme je identifikovali, najdete je níže. Řiďte se pokyny před otázkou, popište situaci, akce a výsledek.",
            "GotPotential_NoQuestions_Description": "Nenašli jsme otázky, které by bylo třeba výrazně zlepšit z hlediska kompetencí a motivací pro tento typ práce. Zdá se, že jste odpověděli velmi dobře.",
            "NotClearMatch_Questions_Description": "Níže jsou otázky, kde může být odpověď vylepšena. Dodržujte pokyny před otázkou, popište situaci, akci a výsledek.",
            "NotClearMatch_NoQuestions_Description": "Nenalezli jsme otázky vyžadující výrazné zlepšení. Mohlo by to být tím, že náboráři nastavili velmi vysokou laťku kvůli velké konkurenci.",
            "NotClearMatch_NoQuestions_DescriptionSecondary": "Obecné doporučení: řiďte se pokyny před otázkou, popište situaci, akce a výsledek. „OK“ nestačí; odpovědi by měly být jasné, ale ne příliš rozsáhlé.",
            "Alert_WantMoreAdvice": "Chcete více rad, jak uspět v pohovoru Hubert?",
            "AlertLink_ExploreOurGeneralAdviceArticle": "Prozkoumejte náš obecný poradenský článek"
        },
        "SimilarOffers": {
            "Title": "Podobné nabídky"
        },
        "HowHubertScoresInterviews": {
            "Title": "Jak Hubert hodnotí pohovory?",
            "Description": "Níže najdete stručné vysvětlení, jak Hubert hodnotí odpovědi v pohovoru, a část o náborovém procesu popisující další kroky po pohovoru.",
            "Tabs_PossibleOutcomes": "Možné výsledky",
            "Tabs_RecruitmentProcess": "Náborový proces",
            "AssessedMatch_Title": "Vyhodnocená shoda",
            "AssessedMatch_Description": "Hubert hodnotí, jak dobře vaše odpovědi odpovídají očekáváním náborářů, a kontroluje, zda splňujete základní požadavky. Podle toho vás zařadí do jedné ze čtyř kategorií níže.",
            "AssessedMatch_DescriptionSecondary": "Hodnocení Huberta je pouze orientační. Konečné rozhodnutí dělá náborář a výsledek mohou ovlivnit i další faktory, například počet kandidátů.",
            "GreatMatch_Title": "Silná shoda",
            "GreatMatch_Description": "Vaše odpovědi se dobře shodují s očekáváními náborářů. Získali jste nadprůměrné skóre a splňujete základní požadavky.",
            "GotPotential_Title": "Silný potenciál, chybí jedna podmínka",
            "GotPotential_Description": "Získali jste nadprůměrné skóre v oblasti zkušeností, motivací a kompetencí, ale nesplňujete jeden či více základních požadavků pro tuto konkrétní pozici.",
            "OkMatch_Title": "Splňujete požadavky, přidejte větší dopad",
            "OkMatch_Description": "Splňujete základní požadavky, ale vaše skóre může být nižší, než náboráři obvykle očekávají.",
            "NotClearMatch_Title": "Možná to zatím není ta správná shoda",
            "NotClearMatch_Description": "Skóre vašich odpovědí je pod úrovní očekávanou náboráři a navíc nesplňujete některé základní požadavky.",
            "ProfessionalExperiences_Title": "Profesní zkušenosti, motivace a kompetence",
            "ProfessionalExperiences_Description": "Otázky zaměřené na vaše zkušenosti, motivaci a kompetence. Jejich výběr určuje náborář.",
            "GreatResults_Title": "Silné odpovědi",
            "GreatResults_Description": "Vaše odpovědi ukazují, že se na danou pozici hodíte.",
            "NotQualified_Title": "Posilte odpovědi",
            "NotQualified_Description": "Vaše odpovědi jsou celkově pod průměrem, který náboráři očekávali.",
            "QualifyingRequirements_Title": "Základní nebo kvalifikační požadavky",
            "QualifyingRequirements_Description": "Otázky týkající se povinných certifikátů, licencí, vzdělání či let praxe určené náborářem.",
            "MeetingRequirements_Title": "Požadavky splněny",
            "MeetingRequirements_Description": "Vaše odpovědi naznačují, že splňujete všechny kvalifikační požadavky. Skvělé.",
            "NotAllExpectationsMet_Title": "Chybí jeden nebo více požadavků",
            "NotAllExpectationsMet_Description": "Zdá se, že nesplňujete jeden či více kvalifikačních požadavků stanovených náborářem.",
            "RecruitmentProcess_Title": "Náborový proces",
            "RecruitmentProcess_Description": "Hubert bývá prvním krokem v procesu s mnoha kandidáty. Všichni dostanou stejné otázky, což zajišťuje férovost, a díky anonymitě minimalizuje Hubert nevědomé předsudky.",
            "EventOne_Title": "Pohovor s Hubertem",
            "EventOne_Description": "Pohovor můžete absolvovat kdykoli a kdekoli. Není časově omezen a můžete si kdykoli dát pauzu.",
            "EventTwo_Title": "Vyhodnocení pohovoru",
            "EventTwo_Description": "Hubert vyhodnotí vaše odpovědi a výsledky jsou pak dostupné vám v My Hubert i náboráři v jejich systému.",
            "EventThree_Title": "Výběr kandidátů",
            "EventThree_Description": "Náboráři si prohlédnou vaše odpovědi a hodnocení. Spolu s dalšími informacemi rozhodnou o dalším kroku, například telefonát, test nebo závěrečný pohovor, případně se rozhodnou pokračovat s jinými kandidáty.",
            "ButtonText_Close": "Zavřít"
        }
    },
    "MyProfile": {
        "Title": "Můj profil",
        "MyDetails": {
            "Title": "Moje údaje",
            "Label_FirstName": "Jméno",
            "Label_LastName": "Příjmení",
            "Label_Email": "E-mail",
            "Label_PhoneNumber": "Telefonní číslo",
            "ButtonText_UpdateDetails": "Aktualizovat údaje",
            "Error_FirstName_Required": "Jméno je povinné.",
            "Error_LastName_Required": "Příjmení je povinné.",
            "Error_Email_Required": "E-mail je povinný.",
            "Error_Email_Invalid": "Zadejte platný e-mail.",
            "Error_PhoneNumber_Invalid": "Telefonní číslo není platné.",
            "Success_Details_Updated": "Profil aktualizován"
        },
        "ChangePassword": {
            "Title": "Změnit heslo",
            "Set_Password_Title": "Vytvořit heslo",
            "Label_CurrentPassword": "Aktuální heslo",
            "Label_NewPassword": "Nové heslo",
            "Label_RepeatNewPassword": "Zopakujte nové heslo",
            "Alert_SignInAgain": "Pro nastavení hesla se prosím přihlaste znovu.",
            "ButtonText_UpdatePassword": "Aktualizovat heslo",
            "ButtonText_SetPassword": "Nastavit heslo",
            "ButtonText_SignInAgain": "Přihlásit se znovu",
            "Error_CurrentPassword_Required": "Aktuální heslo je povinné.",
            "Error_CurrentPassword_DoesntMatch": "Heslo neodpovídá aktuálnímu heslu.",
            "Error_NewPassword_Required": "Nové heslo je povinné.",
            "Error_NewPassword_6_Characters": "Nové heslo musí mít alespoň 6 znaků.",
            "Error_RepeatNewPassword_Required": "Zopakované nové heslo je povinné.",
            "Error_RepeatNewPassword_DoesntMatch": "Hesla se neshodují.",
            "Success_Password_Changed": "Heslo aktualizováno",
            "Error_Invalid_CurrentPassword": "Neplatné aktuální heslo."
        },
        "NotificationPreferences": {
            "Title": "Nastavení oznámení",
            "Label_ReceiveUpdatesToggle": "Chci dostávat novinky od Huberta.",
            "Label_ReceiveUpdatesToggleHelpText": "Získáte kariérní průvodce, tipy na pohovory a další."
        },
        "AccountRemoval": {
            "Title": "Zrušení účtu",
            "ButtonText_RemoveMyAccount": "Smazat můj účet"
        }
    },
    "PreInterviewPage": {
        "Title_Hello": "Ahoj",
        "Subtitle": "Chystáte se zahájit pracovní pohovor.",
        "TipBox_Title": "Pár tipů, které se mohou hodit",
        "TipBox_Tip1": "Absolvujte pohovor na klidném místě, abyste se mohli soustředit a pohodlně psát.",
        "TipBox_Tip2": "Odpovídejte na počítači s klávesnicí (pokud nejste zvyklí hodně psát na mobilu).",
        "TipBox_Tip3": "Buďte co nejkonkrétnější a nejpodrobnější, Hubert i náboráři vás chtějí poznat",
        "TipBox_Tip4": "Dejte si čas; nejsou žádná časová omezení.",
        "TipBox_Tip5": "Kdykoli si můžete dát pauzu a pokračovat později.",
        "TipBox_Tip6": "Buďte sami sebou a přistupte k pohovoru s Hubertem se stejným nasazením jako k osobnímu pohovoru.",
        "CheckAdviceArticle_Text1": "Chcete-li více tipů, jak uspět u pohovoru, podívejte se na tento",
        "CheckAdviceArticle_Text2": "článek",
        "CheckAdviceArticle_Text3": "s užitečnými radami.",
        "ReadyToGetStarted": "Jste připraveni začít?",
        "ORSeparator_Text": "Nebo",
        "ButtonText_StartInterviewNow": "Spustit pohovor nyní",
        "ButtonText_SetReminder": "Nejsem připraven/a, nastavit připomenutí",
        "PrivacyPolicyText": "Kliknutím na Spustit pohovor souhlasíte se",
        "PrivacyPolicyLink": "Zásadami ochrany osobních údajů a Obchodními podmínkami"
    },
    "InterviewCompletedPageInviteEmail": {
        "CompletedAlert_Title": "Skvělá práce",
        "CompletedAlert_Subtitle": "Dokončili jste pohovor.",
        "CompletedAlert_Description": "Náboráři zkontrolují všechny žádosti a poskytnou zpětnou vazbu e-mailem nebo telefonicky, jakmile budou mít zprávu.",
        "InterviewNotCompleted": "Tento pohovor není dokončen."
    },
    "HelpCenter": {
        "BannerSection": {
            "Title": "Centrum nápovědy",
            "Subtitle": "Najděte odpovědi na nejčastější dotazy o Hubertovi.",
            "Label_Search": "hledat často kladené otázky",
            "ButtonText_Search": "Hledat"
        },
        "FAQSection": {
            "Tabs_All": "Vše",
            "Tabs_AboutHubertInterview": "O pohovoru Hubert",
            "Tabs_TechnicalSupport": "Technická podpora"
        },
        "StillHaveQuestion": {
            "Title": "Stále máte otázku?",
            "Description": "Rádi vám pomůžeme.",
            "DropUsAEmail": "Napište nám na hubert@hubert.ai"
        },
        "Q&ATexts": {
            "AboutHubertInterview": [
                {
                    "q": "Mohu pohovor absolvovat telefonicky?",
                    "a": "Hubert v současnosti funguje pouze prostřednictvím chatu. Pokud máte zdravotní omezení, které vám brání absolvovat pohovor, obraťte se přímo na přijímací společnost. Hubert odpovídá pouze za chatový pohovor."
                },
                {
                    "q": "Mohu absolvovat pohovor v jiném jazyce?",
                    "a": "U některých pohovorů je na začátku možnost vybrat jazyk. Pokud tato volba chybí, je porozumění jazyku pravděpodobně požadavkem pozice. V případě dalších dotazů kontaktujte prosím náborovou společnost."
                },
                {
                    "q": "Budu penalizován za krátké odpovědi?",
                    "a": "Nebudete, pokud na otázky odpovíte vhodným způsobem. Neexistuje žádná minimální délka odpovědi."
                },
                {
                    "q": "Mohu znovu použít své odpovědi z jiného pohovoru s Hubertem?",
                    "a": "Ano, pokud se přihlásíte do My Hubert a ucházíte se o podobnou roli, můžete své dřívější odpovědi znovu použít."
                },
                {
                    "q": "Bude můj pohovor číst člověk?",
                    "a": "Ano, naši zákazníci jsou vyzváni k ruční kontrole pohovorů."
                },
                {
                    "q": "Absolvoval(a) jsem pohovor, co se nyní stane?",
                    "a": "Po dokončení pohovoru jsou výsledky odeslány náboráři do jeho systému pro správu žádostí. Náboráři si mohou prohlédnout vaše odpovědi i hodnocení Huberta a podle něj i vlastního úsudku rozhodnou, zda vás pozvou do další fáze náboru. Dalším krokem může být telefonát, pozvánka k testu nebo naplánování závěrečného pohovoru."
                },
                {
                    "q": "Mám dotaz na další kroky v procesu, koho mám kontaktovat?",
                    "a": "Obraťte se prosím na společnost, u které jste se o práci ucházeli."
                },
                {
                    "q": "Jak zajišťujete, že do náborového procesu nevnášíte předsudky?",
                    "a": "Omezení předsudků je pro nás velmi důležité. Jako stroj může být Hubert v hodnocení konzistentnější než člověk. Naše modely navíc trénuje řada odborných hodnotitelů z různých prostředí. Hubert také nezná pohlaví, věk, etnický původ, náboženství ani vzhled kandidátů, běžné zdroje předsudků v tradičních pohovorech."
                },
                {
                    "q": "Mohu mít pohovor s člověkem místo Huberta?",
                    "a": "Ohledně této možnosti se prosím obraťte na společnost, u které jste se ucházeli o práci."
                },
                {
                    "q": "Je Hubert člověk?",
                    "a": "Ne, Hubert je počítačový systém pro vedení a analýzu pohovorů."
                },
                {
                    "q": "Mohu dodatečně změnit své odpovědi?",
                    "a": "Ne, stejně jako u osobního pohovoru nemůžete své odpovědi zpětně upravovat."
                },
                {
                    "q": "Jak uspět v pohovoru s Hubertem?",
                    "a": "Před odpovědí si pečlivě přečtěte otázky, dodržujte pokyny, uvádějte konkrétní příklady ze své praxe a buďte upřímní."
                },
                {
                    "q": "Potřebuji práci, koho mám kontaktovat?",
                    "a": "Obraťte se prosím na společnost, u které jste se ucházeli."
                },
                {
                    "q": "Absolvoval(a) jsem pohovor, ale od té doby jsem nic neslyšel(a). Co mám dělat?",
                    "a": "Na základě hodnocení Huberta a vlastního úsudku náboráři rozhodnou, jestli postoupíte do dalšího kroku. Dalším krokem může být telefonát, test nebo závěrečný pohovor. Pokud dají přednost jiným kandidátům, mohou se rozhodnout ve vaší přihlášce nepokračovat. Pro nejaktuálnější informace kontaktujte náboráře a ověřte stav své přihlášky."
                },
                {
                    "q": "Mám mnoho zkušeností, ale práci jsem nedostal(a). Proč?",
                    "a": "Možná vaše zkušenosti nestačily. Uvědomte si, že o pozici se uchází mnoho kvalifikovaných kandidátů a konkurence je vysoká. Pokud vás odmítli, obraťte se na společnost a zeptejte se na důvod. V My Hubert najdete zpětnou vazbu k odpovědím i další pracovní nabídky."
                },
                {
                    "q": "Jak dlouho trvá pohovor?",
                    "a": "Záleží na počtu otázek nastavených náborářem. Očekávejte 10–25 minut. Nespěchejte; v případě potřeby si můžete dát pauzu a pokračovat později."
                },
                {
                    "q": "Kde si mohu přečíst, jak se nakládá s mými údaji?",
                    "a": "https://www.hubert.ai/candidate-privacy-policy"
                }
            ],
            "TechnicalSupport": [
                {
                    "q": "Proč nevidím své předchozí pohovory s Hubertem?",
                    "a": "Ujistěte se, že jste k žádosti o práci použili stejnou e-mailovou adresu, jakou používáte pro přihlášení do My Hubert. To platí i pro přihlášení přes Google. Pokud ne, vytvořte si účet s e-mailem použitým v žádosti."
                },
                {
                    "q": "Proč jsem nedostal(a) e-mail k pohovoru?",
                    "a": "Zkontrolujte složku spam. Přidejte si adresu hubert@hubert.ai do kontaktů nebo se přihlaste do My Hubert (stejným e-mailem jako v přihlášce) a najděte odkaz na pohovor tam."
                },
                {
                    "q": "Nemohu najít odkaz na pohovor ve svém e-mailu.",
                    "a": "Přesuňte e-mail ze spamu do doručené pošty nebo se přihlaste do My Hubert (stejným e-mailem jako v přihlášce) a v části „Moje pohovory“ odkaz najdete."
                },
                {
                    "q": "Funguje pohovor na mobilních zařízeních?",
                    "a": "Ano! Pokud se vám však pohodlněji píše na počítači, použijte raději počítač."
                },
                {
                    "q": "Pohovor nefunguje, co mám dělat?",
                    "a": "Omlouváme se. Napište nám na hubert@hubert.ai a pomůžeme vám."
                },
                {
                    "q": "Chci smazat svůj účet v My Hubert, co mám dělat?",
                    "a": "Napište nám na hubert@hubert.ai a my vám s tím pomůžeme."
                },
                {
                    "q": "Pohovor byl přerušen, jak se k němu vrátím?",
                    "a": "Klikněte na odkaz v e-mailové pozvánce a pokračujte, kde jste skončili, nebo se přihlaste do My Hubert a klikněte na pohovor v části „Moje pohovory“."
                }
            ]
        }
    },
    "LearnWithHubert": {
        "BannerSection": {
            "Title": "Učte se s Hubertem",
            "Subtitle": "Zjistěte, jak zvýšit své šance v náboru a podávat lepší výkon v práci.",
            "Label_Search": "hledat průvodce pohovorem a kariérou",
            "ButtonText_Search": "Hledat"
        },
        "TabSelector": {
            "MyFeed": "Můj feed",
            "InterviewGuides": "Průvodci pohovory",
            "CareerGuides": "Kariérní průvodci"
        },
        "NewestOnTheFeed": "Nejnovější v kanálu",
        "PickedForMe": "Nejnovější články",
        "InterviewGuides": "Průvodci pohovory",
        "CareerGuides": "Kariérní průvodci"
    },
    "Article": {
        "ButtonText_BackToAllArticles": "Zpět na všechny články"
    },
    "ForgotPassword": {
        "ResetLinkAlert_Title": "Obnovte své heslo",
        "ResetLinkAlert_Subtitle": "Kliknutím na odkaz pro obnovení hesla, který jsme vám poslali e-mailem, nastavíte nové heslo a přihlásíte se.",
        "PasswordNotSetAlert_Message": "Heslo není nastaveno, přihlaste se prosím pomocí",
        "ResetYourPassword": {
            "MainTitle": "Chcete vidět výsledky svého pohovoru s Hubertem?",
            "Subtitle": "Přihlaste se, abyste viděli výsledky, získali zpětnou vazbu, přečetli si rady a mnohem více.",
            "FormSectionTitle": "Obnovte své heslo",
            "Label_NewPassword": "Nové heslo",
            "Label_ConfirmNewPassword": "Potvrďte nové heslo",
            "Error_NewPassword_Required": "Zadejte nové heslo.",
            "Error_Password_6_Characters": "Vaše nové heslo musí mít alespoň 6 znaků.",
            "Error_ConfirmNewPassword_Required": "Musíte potvrdit nové heslo.",
            "Error_ConfirmNewPassword_NotMatch": "Heslo se neshoduje s novým heslem",
            "Error_MalformedResetUrl": "Neplatný bezpečnostní kód. Zkuste to znovu",
            "Error_ResetPasswordFailed": "Při obnově hesla došlo k problému. Zkuste to znovu",
            "Error_WeakPassword": "Heslo musí mít alespoň 6 znaků.",
            "Error_InvalidCode_Title": "Žádost o reset hesla vypršela nebo je neplatná.",
            "Error_InvalidCode_Subtitle": "Zkuste prosím heslo resetovat znovu",
            "ButtonText_SetNewPassword": "Nastavit nové heslo a přihlásit se",
            "ButtonText_RememberYourPassword": "Pamatujete si heslo?",
            "ButtonText_SignInInstead": "Přihlásit se místo toho"
        }
    },
    "PageNotFound": {
        "Title": "Stránka nenalezena",
        "Description": "Ups, nemůžeme najít stránku, kterou hledáte.",
        "ButtonText_GoToDashboard": "Přejít na Přehled",
        "ButtonText_GoToLogin": "Přejít na Přihlášení"
    },
    "OldInterviewRedirectionModal": {
        "DescriptionLine1": "Pro informaci: opětovné použití odpovědí zatím pro tento pohovor není dostupné. Očekáváme, že bude dostupné v nadcházejících dnech či týdnech, ale pohovor můžete i tak absolvovat.",
        "DescriptionLine2": "Pokračujte k pohovoru kliknutím na tlačítko níže.",
        "ButtonText_TakeMeToTheInterview": "Přejít na pohovor"
    },
    "UnsubscribeFromEmails": {
        "Title": "Jste si jistý/á?",
        "Subtitle": "Přestanete od nás dostávat e-maily ohledně této práce.",
        "SelectTheReason": "Vyberte prosím důvod z možností níže.",
        "ReasonText1": "Našel/našla jsem si jinou práci.",
        "ReasonText2": "O tuto práci již nemám zájem.",
        "ReasonText3": "Jiné",
        "ButtonText_Unsubscribe": "Odhlásit odběr k této práci",
        "Placeholder_YourReason": "Váš důvod",
        "Success_Title": "Úspěšně jste se odhlásili od dalších e-mailů k této práci.",
        "Loading": "Načítání...",
        "Error_YourReason_Required": "Zadejte prosím důvod.",
        "Error_ServerIssue": "Odhlášení se nezdařilo kvůli chybě serveru."
    },
    "SocialLoginCallback": {
        "ButtonText_TryAgain": "Zkusit znovu"
    },
    "Outreach": {
        "CandidateNotFound": "Kandidát nenalezen",
        "CandidateNotFoundDesc": "Nepodařilo se nám najít podrobnosti o pohovoru, které hledáte.",
        "InterviewEnded": "Pohovor ukončen",
        "InterviewEndedDesc1": "Tato relace pohovoru skončila nebo již není k dispozici.",
        "InterviewEndedDesc2": "Děkujeme za váš čas. Máte-li jakékoli dotazy, kontaktujte prosím náborový tým.",
        "ReadyTitle": "Jste připraveni na svůj pohovor, {{firstName}}?",
        "InvitationDesc": "Hubert vás jménem společnosti {{companyName}} zve k pohovoru přes chat, který trvá přibližně 1–2 minuty.",
        "Button_StartChat": "Zahájit chatovací pohovor",
        "CancelNotice": "Zahájení zde zruší naplánovaný hovor pro tuto pozici.",
        "PreferNotToContinue": "Raději byste nepokračovali?",
        "DeclineLabel": "O tuto pozici nemám zájem. Prosím, již mě v souvislosti s touto pozicí nekontaktujte.",
        "Button_ConfirmAndDecline": "Potvrdit a odmítnout",
        "Processing": "Zpracovávání...",
        "Toast_DeclineSuccess": "Pohovor byl úspěšně odmítnut",
        "Toast_CancelVoiceInfo": "Hlasový pohovor zrušen. Funkce bude brzy k dispozici.",
        "Toast_CancelError": "Nepodařilo se zrušit pohovor. Zkuste to prosím znovu.",
        "Footer_WithdrawConsent": "Svůj souhlas můžete kdykoli odvolat. Více se dozvíte v ",
        "Footer_PrivacyPolicySuffix": "zásadách ochrany osobních údajů společnosti ",
        "Footer_And": " a v ",
        "Footer_HubertPrivacyLink": "zásadách ochrany osobních údajů a smluvních podmínkách společnosti Hubert",
        "Chat_InterviewWith": "Pohovor se společností {{companyName}}",
        "Chat_StatusConnected": "Připojeno",
        "Chat_StatusError": "Chyba",
        "Chat_StatusDisconnected": "Odpojeno",
        "Chat_StatusConnecting": "Připojování...",
        "Chat_ReadyToStart": "Připraveni zahájit pohovor?",
        "Chat_ButtonStart": "Zahájit pohovor",
        "Chat_SayHello": "Pozdravte a zahajte konverzaci.",
        "Chat_EmptyState": "Pošlete zprávu a zahajte pohovor.",
        "Chat_Placeholder": "Napište svou zprávu...",
        "Chat_ButtonSend": "Odeslat",
        "Chat_ButtonBack": "Zpět",
        "LoadingCandidateDetails": "Načítání podrobností o kandidátovi...",
        "FetchingCandidateDetails": "Získávání podrobností o kandidátovi...",
        "Chat_StatusReady": "Čekání na připojení...",
        "Chat_ForbiddenError": "Tento chatovací pohovor již není k dispozici.",
        "Chat_GeneralError": "Nepodařilo se zahájit chat. Zkuste to prosím později znovu.",
        "Chat_SelectUiLanguage": "Jazyk nabídky",
        "Chat_SelectLanguage": "Vyberte svůj jazyk",
        "Chat_InterviewTitle": "Pracovní pohovor"
    }
}
